<section class="flex flex-col items-center gap-12">
  <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <h3 class="text-xl font-bold md:text-2xl">Email</h3>
      <p class="text-pretty text-lg">
        Reach out to our support team for assistance with any issues or
        questions via
        <a [href]="'mailto:' + emailSupport" target="_blank">{{
          emailSupport
        }}</a
        >.
      </p>
    </div>
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <h3 class="text-xl font-bold md:text-2xl">Social Media</h3>
      <p class="text-pretty text-lg">
        Follow us on our social media channels for the latest updates and news.
      </p>
      <p class="text-pretty text-lg">
        Connect with us on
        <a [href]="xUrl" target="_blank">X (Twitter)</a>,
        <a [href]="linkedinUrl" target="_blank">LinkedIn</a> and
        <a [href]="youtubeUrl" target="_blank">YouTube</a>.
      </p>
    </div>
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <h3 class="text-xl font-bold md:text-2xl">Community</h3>
      <p class="text-pretty text-lg">
        Join our community on
        <a [href]="discordUrl" target="_blank">Discord</a> to connect with other
        users, share experiences, and get help from fellow developers.
      </p>
    </div>
  </div>
</section>
